import { apiInstances } from '../../../../libs';

const { post } = apiInstances.notificationInstance;

export function saveUserDevice(payload) {
  try {
    return post(`/users/devices`, payload);
  } catch (error) {
    throw error;
  }
}
